<script>
import appHeader from "../components/app-header";
import appCallouts from "../components/app-callouts";
import appNotifications from "../components/app-notifications";

export default {
  name: "layout-dashboard",
  components: {
    appHeader,
    appCallouts,
    appNotifications
  },
  data() {
    return { intervalAccount: null };
  },
  created() {
    this.accountSetup();
    this.intervalAccountSetup();
  },
  beforeDestroy() {
    clearInterval(this.intervalAccount);
  },
  computed: {
    loggedIn() {
      return this.$store.getters["authentication/loggedIn"];
    }
  },
  watch: {
    loggedIn() {
      this.intervalAccountSetup();
    }
  },
  methods: {
    accountSetup() {
      this.$store.dispatch("authentication/refreshUser");
    },
    intervalAccountSetup() {
      if (this.loggedIn) {
        this.intervalAccount = setInterval(
          function() {
            console.log("intervalAccount");
            this.accountSetup();
          }.bind(this),
          60000 * 5
        );
      } else {
        console.log("DISABLE INTERVAL");
        clearInterval(this.intervalAccount);
      }
    }
  }
};
</script>

<template>
  <div class="layout-dashboard">
    <app-header />
    <app-callouts />
    <div id="sapp__view">
      <slot />
    </div>
    <app-notifications />
  </div>
</template>
